/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const o=1,t=[0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1],c=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],e=256;export{t as alphaToRgbaChannelSelectorMatrix,c as rgbaToRgbaChannelSelectorMatrix,e as shadeTextureSize,o as sigma};
